import React, { useEffect, useRef, useState } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from 'react-image-crop'
import { sliceString } from "src/util/functions";
import { Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import InputForm from "./ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import "./styles.css";
import 'react-image-crop/dist/ReactCrop.css'

const TO_RADIANS = Math.PI / 180

const FORMATOSACEPTADOS = ["png", "jpg", "jpeg"]
const MESSAGE = `Para agregar una imagen, puedes arrastrarla hasta aquí o seleccionarla presionando el siguiente botón. Asegúrate de elegir una imagen con un formato (${FORMATOSACEPTADOS.join(", ")}) y tamaño adecuados para su uso en la aplicación.`

const ImagePickerCrop = ({ previewRef, urlImagen, ratio }) => {
    const dispatch = useDispatch();
    const imgRef = useRef(null)
    const previewCanvasRef = useRef(null)
    const [fileName, setFileName] = useState("")
    const [imgSrc, setImgSrc] = useState("")
    const [scale, setScale] = useState(1)
    const [rotate, setRotate] = useState(0)
    const [aspect, setAspect] = useState(ratio)
    const [styleDrag, setStyleDrag] = useState(false)
    const [crop, setCrop] = useState()
    const [completedCrop, setCompletedCrop] = useState()

    useEffect(() => {
        if(ratio) {
            setAspect(ratio)
        }else if (imgRef.current) {
            const { width, height } = imgRef.current
            setAspect(16 / 9)
            setCrop(centerAspectCrop(width, height, 16 / 9))
        }
    }, [])

    useDebounceEffect(
        async () => {
            if (previewCanvasRef.current) previewRef.current = previewCanvasRef.current

            if ( completedCrop?.width && completedCrop?.height && imgRef.current && previewCanvasRef.current ){
                canvasPreview({
                    image: imgRef.current,
                    canvas: previewCanvasRef.current,
                    crop: completedCrop,
                    scale,
                    rotate,
                })
            }
        }, 100, [completedCrop, scale, rotate],
    )

    const onImageLoad = (e) => {
        const { width, height } = e.currentTarget
        setCrop(centerAspectCrop(width, height, aspect ?? 1))
    }

    const onUploadFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0]

            const fileFormat = file.name.split(".").pop().toLowerCase()

            if(FORMATOSACEPTADOS.includes(fileFormat)){
            setCrop(undefined)
            setFileName(file.name)

            const reader = new FileReader()

            reader.addEventListener("load", (e) => setImgSrc(reader.result?.toString() || ""))
            reader.readAsDataURL(file)
            }else{
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Formato no aceptado' } });
        }
    }
    }

    const onDrop = (e) => {
        e.preventDefault()

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0]
            const fileFormat = file.name.split(".").pop().toLowerCase()

            if(FORMATOSACEPTADOS.includes(fileFormat)){
            setStyleDrag(false)
            setCrop(undefined)
            setFileName(file.name)

            const reader = new FileReader()
            reader.addEventListener("load", (e) => setImgSrc(reader.result?.toString() || ""))
            reader.readAsDataURL(file)
            }else {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Formato no aceptado' } });
            }
        }
    }

    const onDragOver = (e) => {
        e.preventDefault()
        setStyleDrag(true)
    }

    const onDragLeave = (e) => {
        e.preventDefault()
        setStyleDrag(false)
    }

    return (
        <div className="containerImageCrop">
            <span className="titleImageCrop mb-2 ml-2">{MESSAGE}</span>


            <Tooltip title="Cargar Imagen" aria-label="Cargar Imagen" placement="top-end">
                <label
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    className={`
                        ${urlImagen != "" && imgSrc == "" ? "labelImageCropEdit" : "labelImageCrop"}
                        ${imgSrc != "" ? "labelImageCropHorizontal" : ""}
                        ${styleDrag ? "activeDrag" : ""}
                    `}
                >
                    <i className="fa fa-camera" style={{fontSize: imgSrc == "" ? "25px" : "20px"}}></i>

                    {urlImagen != "" && imgSrc == "" && (
                        <img
                            src={urlImagen}
                            alt="Imagen Asignada"
                        />
                    )}

                    <input
                        accept="image/png,image/jpeg"
                        className="inputImageCrop"
                        type="file"
                        onChange={onUploadFile}
                    />
                    <span>{sliceString(fileName, 40)}</span>
                </label>
            </Tooltip>

            {!!imgSrc && (
                <div className="w-100 row m-0 p-0 px-2 mt-3 d-flex justify-content-center align-items-center">
                    <div className="col-5 containerEdicionImageCrop">
                        <span className="titleSectionImageCrop">Edición de la imagen:</span>

                        <div className="containerCrop">
                            <div>
                                <ReactCrop
                                    crop={crop}
                                    onChange={(_, percentCrop) => setCrop(percentCrop)}
                                    onComplete={(c) => setCompletedCrop(c)}
                                    aspect={aspect}
                                >
                                    <img
                                        src={imgSrc}
                                        ref={imgRef}
                                        onLoad={onImageLoad}
                                        className="imgCrop"
                                        style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                                    />
                                </ReactCrop>
                            </div>
                        </div>
                    </div>

                    <div className="col-2 containerControlsImageCrop">
                        <InputForm
                            inputProps={{ step: "0.1" }}
                            value={scale}
                            handleChange={({ _, value }) => setScale(value)}
                            identificador="scale"
                            label="Escalado"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="w-100 px-1"
                        />

                        <InputForm
                            inputProps={{}}
                            value={rotate}
                            handleChange={({ _, value }) => setRotate(value)}
                            identificador="rotate"
                            label="Rotación"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="w-100 px-1 mt-1"
                        />
                    </div>

                    <div className="col-5 containerPrevisualizacionImageCrop">
                        <span className="titleSectionImageCrop">Previsualización de la imagen:</span>
                        {!!completedCrop && (
                            <div className="containerPrev">
                                <canvas
                                    ref={previewCanvasRef}
                                    style={{ objectFit: "contain",  width: completedCrop.width, height: completedCrop.height }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

const centerAspectCrop = (mediaWidth, mediaHeight, aspect) => {
    return centerCrop(
        makeAspectCrop(
            {
                unit: "%",
                width: 100,
                height: 100
            },
            aspect,
            mediaWidth,
            mediaHeight
        ),
        mediaWidth,
        mediaHeight
    )
}

const canvasPreview = ({ image, canvas, crop, scale = 1, rotate = 0 }) => {
    const ctx = canvas.getContext("2d")

    if(!ctx) return

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height

    const pixelRatio = 1/* window.devicePixelRatio */

    canvas.width = Math.floor(crop.width * pixelRatio * scaleX)
    canvas.height = Math.floor(crop.height * pixelRatio * scaleY)

    ctx.scale(pixelRatio, pixelRatio)
    ctx.imageSmoothingQuality = 'high'

    const cropX = crop.x * scaleX
    const cropY = crop.y * scaleY

    const rotateRads = rotate * TO_RADIANS
    const centerX = image.naturalWidth / 2
    const centerY = image.naturalHeight / 2

    ctx.save()

    ctx.translate(-cropX, -cropY)
    ctx.translate(centerX, centerY)
    ctx.rotate(rotateRads)
    ctx.scale(scale, scale)
    ctx.translate(-centerX, -centerY)
    ctx.drawImage( image, 0, 0, image.naturalWidth, image.naturalHeight, 0, 0, image.naturalWidth, image.naturalHeight )

    ctx.restore()
}

const useDebounceEffect = (fn, delay, deps) => {
    useEffect(() => {
        const handler = setTimeout(() => fn(undefined, deps), delay)

        return () => clearTimeout(handler)
    }, [deps])
}

export default ImagePickerCrop
